import LayoutLogin from '../../layouts/LayoutLogin';
import Login from '../../pages/LoginComponent/Login';
import LoginGuest from '../../pages/LoginComponent/LoginGuest';
import Select_Agency from '../../pages/LoginComponent/Select_Agency';
import RouterRender from '../routerRender';
import R from './Router';

const Router = (): any => [
  RouterRender([
    {
      link: R.HomeLogin.link,
      layout: LayoutLogin,
      component: Login
    },
    {
      link: 'LoginGuest',
      layout: LayoutLogin,
      component: LoginGuest
    },
    {
      link: '/select-agency',
      layout: LayoutLogin,
      component: Select_Agency
    },
  ]),
].map((router: any) => router);

export default Router();